export const QuestionType = Object.freeze({
  BINARY: 'BINARY',
  LIKERT3: 'LIKERT3',
  LIKERT5: 'LIKERT5',
  LIKERT7: 'LIKERT7',
  MULTIPLE: 'MULTIPLE',
  toString(status) {
    switch (status) {
      case QuestionType.BINARY:
        return 'Binária'
      case QuestionType.LIKERT3:
        return 'Likert-3'
      case QuestionType.LIKERT5:
        return 'Likert-5'
      case QuestionType.LIKERT7:
        return 'Likert-7'
      case QuestionType.MULTIPLE:
        return 'Múltipla escolha'
      default:
        return ''
    }
  }
})
